import React, { Component } from "react";
import ReactRoundedImage from "react-rounded-image";
import logo from "../../../assets/img/brand/wizmen.png";
import alQadir from "../../../assets/img/alqadirCertificate.jpg";
import alQadirLogo from "../../../assets/img/AlQadirLogo.png";
import FBRlogo from "../../../assets/img/FBR_Logo.jpeg";
import Signature from "../../../assets/img/hameedSignatureQadir.jpg";
import { Col, Row, Container, FormGroup, Input, Label } from "reactstrap";
import { baseurl } from "../../../baseurl.js";
import { headers, companyId, username, token } from "../../../utils/variables";
import { Redirect } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import Responseloader from "../ShortCutComponents/ResponseLoader";
import "./alQadirPrintCss.css";
import QRCode from "react-qr-code";

var thisContex;
// var token = localStorage.getItem("token");
// var username = localStorage.getItem("username");
var UserName = localStorage.getItem("firstName");
// var token = localStorage.getItem("token");
// var companyId = localStorage.getItem("companyId");
var companylog = localStorage.getItem("profile_pic");
var companyName = localStorage.getItem("companyName");
var saleTaxGroup = localStorage.getItem("saleTaxGroup");
let companySym;
// let companySym = `${baseurl}/getImages/companyLogoImg/?fileName=${companylog}`;
/////////////////////////////-------------------ClassComponents Start Here----------///////////////////////////
class PrintView extends Component {
  constructor(props) {
    super(props);

    let tempLogedIn = false;
    //////////////------------Token for Login prepose True and False Condition----------///////////////////////
    if (token != null) {
      tempLogedIn = true;
    }
    let propInvoiceId = this.props?.location?.state?.id || this.props?.id || [];
    if (!Array.isArray(propInvoiceId)) {
      propInvoiceId = [propInvoiceId];
    }
    // let propInvoiceId = 746;
    propInvoiceId = propInvoiceId ? propInvoiceId : -1;
    console.log("this.prop", this.props);
    console.log("this.prop", this.props?.location?.state?.headerPrefix);
    //////////////-------Components this States here to use in only Class Components ------///////////////////////
    this.state = {
      logInStatus: tempLogedIn,
      invoiceNo: "",
      transType: "",
      remarks: "",
      poNumber: "",
      issueDate: "",
      dueDate: "",
      companyName: companyName,
      clientName: "",
      viYearMake: "",
      zipCode: "",
      viModel: "",
      licenseNo: "",
      compNtn: "",
      compStrn: "",
      clntCnic: "",
      clntNtax: "",
      clntStrn: "",
      fbr_inv_id: "",
      ExpenseDesc: "",
      vehicleIdNo: "",
      viMileage: "",
      city: "",
      tireFee: "",
      state: "",
      loadingResponce: true,
      setNextPrintPageFooter: false,
      setFooterData: [],
      labour: "",
      TireFee: "",
      TireDispossal: "",
      headerPrefix:
        this.props?.location?.state?.headerPrefix === "NOT GRN OR PO"
          ? "Invoice"
          : this.props?.location?.state?.headerPrefix,
      total_fet: 0,
      zip: "",
      disTotalItems: -1,
      sub_Amount_total_items: -1,
      total_Amount: -1,
      total_btAmount: -1,
      invoiceId: propInvoiceId,
      downloadLink: null,
    };
    thisContex = this;
    companySym = `${baseurl}/getImages/labelCard/?fileName=${companylog}`;
  }
  componentDidMount() {
    this.getAllPrints();
  }
  downloadInvoice() {
    const element = document.getElementById("pdfContent");
  }

  convertToCurrency(param_number) {
    return param_number !== 0 && param_number !== null && param_number > 0
      ? Number(
          param_number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        )?.toFixed(2)
      : 0;
  }
  componentDidUpdate(prevProps) {}
  getFooterDataWithId = (id, dataLength) => {
    thisContex.setState({ loadingResponce: true });
    return axios
      .post(
        `${baseurl}/masterData/getDocFooterSetupId`,
        { id, companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        let response = res.data.data[0];
        console.log("hhhhh", response);
        let label;
        if (response.page_size === "F") {
          label = "Full";
        } else {
          label = "Half";
        }
        const formValuesFooterData = [];

        if (response.desc1 !== null) {
          formValuesFooterData.push({
            desc: response.desc1,
            enteredBy: response.Ent_by_1,
          });
        }
        if (response.desc_2 !== null) {
          formValuesFooterData.push({
            desc: response.desc_2,
            enteredBy: response.Ent_by_2,
          });
        }
        if (response.desc_3 !== null) {
          formValuesFooterData.push({
            desc: response.desc_3,
            enteredBy: response.Ent_by_3,
          });
        }
        if (response.desc_4 !== null) {
          formValuesFooterData.push({
            desc: response.desc_4,
            enteredBy: response.Ent_by_4,
          });
        }
        if (response.desc_5 !== null) {
          formValuesFooterData.push({
            desc: response.desc_5,
            enteredBy: response.Ent_by_5,
          });
        }
        if (response.desc_6 !== null) {
          formValuesFooterData.push({
            desc: response.desc_6,
            enteredBy: response.Ent_by_6,
          });
        }
        console.log("hhhhh>", formValuesFooterData);
        if (formValuesFooterData.length > 3 && dataLength > 25) {
          thisContex.setState({ setNextPrintPageFooter: true });
        } else {
          thisContex.setState({ setNextPrintPageFooter: false });
        }
        thisContex.setState({ setFooterData: formValuesFooterData });
        return formValuesFooterData.length;
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(function () {
        thisContex.setState({ loadingResponce: false });
      });
  };
  
  getAllPrints = async () => {
    let { invoiceId, companyName } = this.state;
    this.setState({ loadingResponce: true });
    try {
      const responses = await Promise.all(
        invoiceId?.map((id) => {
          return axios.post(
            `${baseurl}/masterData/getAlQadirSalesPrint`,
            { username, companyName, invoiceId: id, companyId },
            headers
          );
        })
      );
      const invoices = responses.map((response) => {
        let res_mt = response.data?.data?.[0] || {};
        let res_det = response.data?.data1 || [];
        
        let total_Amount = 0;
        let total_btAmount = 0;
        let totalsalesTax = 0;
        let discount = 0;
        for (let i = 0; i < res_det.length; i++) {
            totalsalesTax += res_det[i].item_sale_tax_amount || 0;
            discount += res_det[i].item_discount || 0;
            total_Amount += res_det[i].at_amount || 0;
            total_btAmount += res_det[i].item_bt_amount || 0;
        }
        
        return {
          ...res_mt,
          res_det,
          total_Amount,
          total_btAmount,
          totalsalesTax,
          discount,
          issueDate: res_mt.issueDate ? moment(res_mt.issueDate).format('DD-MM-YYYY') : '',
          dueDate: res_mt.dueDate ? moment(res_mt.dueDate).format('DD-MM-YYYY') : '',
          clientName: res_mt.Client_Name,
          compNtn: res_mt.comp_ntn,
          compStrn: res_mt.comp_saleTaxNo,
          clntCnic: res_mt.client_cnic,
          clntNtax: res_mt.client_ntax,
          clntStrn: res_mt.client_strn,
          fbr_inv_id: res_mt.fbr_inv_id ? res_mt.fbr_inv_id : 'N/A',
          poNumber: res_mt.INVOICE_REF_NO,
          invoiceNo: res_mt.DOCUMENT_NO,
          address: res_mt.supplierAdress,
          email: res_mt.email,
          phone: res_mt.phone,
          remarks: res_mt.remarks,
          city: res_mt.customer_city,
          company_no: res_mt.company_no,
          CURRENCY_DESC: res_mt.CURRENCY_DESC,
          invBookId: res_mt.INV_BOOK_ID,
          totalReceived: 0,
          totalAccepted: 0,
          totalRejected: 0,
          dynamicInvMessage: 'Invoice',
          specificMsg: '',
          ExpenseDesc: res_det[0]?.Expense_Desc,
          Item_Desc_Lov: res_det[0]?.Item_Desc_Lov,
          state: res_mt.state_label
        };
      });
      if (invoices.length > 0 && invoices[0].INV_BOOK_ID) {
        this.getFooterDataWithId(invoices[0].INV_BOOK_ID, invoices[0].res_det?.length || 0);
      }
      this.setState({ invoices, loadingResponce: false });
    } catch (err) {
      console.log(err);
      this.setState({ loadingResponce: false, errorMessage: err.message || JSON.stringify(err) });
    }
  };

  getPrintCall() {
    let invLable;
    axios
      .post(`${baseurl}/auth/getCompany`, {
        username: username,
      })
      .then((response) => {
        var data = response.data.data;

        for (let index = 0; index < data.length; index++) {
          //  console.log('data :  >> ', data  , data[index].COMPANY_ID , data[index].LABEL , data[index].COMPANY_ID == companyId);
          if (data[index]?.COMPANY_ID == companyId)
            invLable = data[index]?.LABEL;
        }
        console.log("invLable......", invLable, companylog);
        companySym = `${baseurl}/getImages/labelCard/?fileName=${invLable}`;
      })
      .catch((error) => {
        console.log(error);
      });
    const { state } = this.props?.location;

    // let invoiceId = 7;
    if (this.state.invoiceId !== -1) {
      thisContex.setState({ loadingResponce: true }); //AHMAD

      //   if (state?.printType === "Purchase") {
      let endPoint =
        state?.headerPrefix === "Purchase Order"
          ? "getPrintPurchaseOrderView"
          : state?.headerPrefix === "GOODS RECEIPT NOTE"
          ? "getGrnPrintView"
          : state?.headerPrefix === "Sale" ||
            state?.headerPrefix === "Invoice Draft" ||
            state?.headerPrefix === "Sale Return"
          ? "getSalesPrint"
          : state?.headerPrefix === "Sale Order"
          ? "getSalesOrderPrint"
          : state?.headerPrefix === "Item Adjusment"
          ? "getItemAdjustmentPrint"
          : state?.headerPrefix === "Production Note"
          ? "getProductionNotePrint"
          : "getPrintPurchaseView";
      // alert(endPoint);
      axios
        .post(
          //   `${baseurl}/masterData/${endPoint}`,
          `${baseurl}/masterData/getAlQadirSalesPrint`,
          {
            username,
            companyName,
            invoiceId: state?.id,
            // invoiceId: 746,
            companyId,
          },
          headers
        )
        .then(function (response) {
          let res_mt = response.data.data[0];
          let res_det = response.data.data1;
          let total_Amount = 0;
          let total_btAmount = 0;
          let discount = 0;
          let invoiceNo = res_mt?.["DOCUMENT_NO"];
          let invBookId = res_mt?.["INV_BOOK_ID"];
          let compNtn = res_mt?.["comp_ntn"];
          let compStrn = res_mt?.["comp_saleTaxNo"];
          let clntCnic = res_mt?.["client_cnic"];
          let clntNtax = res_mt?.["client_ntax"];
          let clntStrn = res_mt?.["client_strn"];
          let fbr_inv_id = res_mt?.["fbr_inv_id"];

          let poNumber = res_mt?.["INVOICE_REF_NO"];
          let issueDate = res_mt?.["issueDate"];
          let dueDate = res_mt?.["dueDate"];
          let remarks = res_mt?.["remarks"];
          let city = res_mt?.["customer_city"];
          let clientName = res_mt?.["Client_Name"];
          let totalsalesTax = 0;
          let totalReceived = 0;
          let totalAccepted = 0;
          let totalRejected = 0;
          let ExpenseDesc = res_det[0]?.["Expense_Desc"];
          let Item_Desc_Lov = res_det[0]?.["Item_Desc_Lov"];
          let address = res_mt?.["supplierAdress"];
          let email = res_mt?.["email"];
          let phone = res_mt?.["phone"];
          let CURRENCY_DESC = res_mt?.["CURRENCY_DESC"];
          let company_no = res_mt?.["company_no"];
          let dynamicInvMessage =
            state?.headerPrefix === "Item Adjusment" ||
            state?.headerPrefix === "Production Note" ||
            state?.headerPrefix === "GOODS RECEIPT NOTE"
              ? ""
              : "Invoice";
          // let state = res_mt?.["state_label"];
          let specificMsg =
            state?.headerPrefix === "Item Adjusment" ||
            state?.headerPrefix === "Production Note" ||
            state?.headerPrefix === "GOODS RECEIPT NOTE"
              ? "Doc"
              : "";

          for (let index = 0; index < res_det.length; index++) {
            //   sub_Amount_total_items += res_det[index].TC_AMOUNT;
            totalsalesTax += res_det[index].item_sale_tax_amount;
            discount += res_det[index].item_discount;
            total_Amount += res_det[index].at_amount;
            total_btAmount += res_det[index].item_bt_amount;
          }
          if (invBookId) {
            thisContex.getFooterDataWithId(
              res_mt?.["INV_BOOK_ID"],
              res_det.length
            );
          }
          thisContex.setState({
            loadingResponce: true,
            invoiceNo: invoiceNo,
            poNumber: poNumber,
            issueDate: moment(issueDate).format("DD-MM-YYYY"),
            dueDate: moment(dueDate).format("DD-MM-YYYY"),
            clientName: clientName,
            compNtn,
            compStrn,
            clntCnic,
            clntNtax,
            clntStrn,
            fbr_inv_id: fbr_inv_id ? fbr_inv_id : "N/A",
            res_det: res_det,
            ExpenseDesc,
            Item_Desc_Lov,
            total_Amount: total_Amount,
            total_btAmount: total_btAmount,
            discount,
            totalsalesTax,
            totalReceived,
            totalAccepted,
            totalRejected,
            address,
            remarks,
            email,
            city,
            phone,
            company_no,
            CURRENCY_DESC,
            invBookId,
            dynamicInvMessage,
            specificMsg,
            state,
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }

  goBackToInvoice() {
    console.log(
      "ridirect............",
      this.props?.location?.state?.updateCheck
    );
    console.log("ridirect............", this.props?.location?.state);
    this.setState({
      goBack: true,
    });
  }

  render() {
    const {
      invoiceId,
      logInStatus,
      invoiceNo,
      transType,
      poNumber,
      issueDate,
      dueDate,
      companyName,
      clientName,
      compNtn,
      compStrn,
      clntCnic,
      clntNtax,
      clntStrn,
      fbr_inv_id,
      total_Amount,
      total_btAmount,
      totalsalesTax,
      totalReceived,
      totalAccepted,
      totalRejected,
      discount,
      saleTaxAmount,
      salesTax,
      phone,
      email,
      ExpenseDesc,
      Item_Desc_Lov,
      remarks,
      city,
      state,
      company_no,
      address,
      goBack,
      CURRENCY_DESC,
      dynamicInvMessage,
      headerPrefix,
      loadingResponce,
      specificMsg,
    } = this.state;
    if (!logInStatus) return <Redirect to="/login" />;
    else if (loadingResponce) {
      return <Responseloader />;
    } else if (goBack) {
      return (
        <Redirect
          // to="/CreativeInvoice"
          push
          to={{
            pathname: this.props?.location?.state?.url,
            state: {
              id: this.state.invoiceId,
              updateCheck: this.props?.location?.state?.updateCheck, //AHMAD
              // updateCheck: 2, //AHMAD
            },
          }}
        />
      );
    } else if (this.state.invoices?.length > 0) {
      return (
        <div>
          {this.state.invoices.map((inv, index) => {
            const {
              invoiceNo, poNumber, issueDate, dueDate, clientName,
              compNtn, compStrn, clntCnic, clntNtax, clntStrn, fbr_inv_id,
              total_Amount, total_btAmount, totalsalesTax, discount,
              address, email, phone, specificMsg, dynamicInvMessage, res_det,
              remarks, city, state, company_no, CURRENCY_DESC, ExpenseDesc, Item_Desc_Lov
            } = inv;
            return (
        <div key={index} className="pdfContent-Print" id="pdfContent-Print" style={{ pageBreakAfter: 'always' }}>
          <Row className="app-body-Invoice bg-white">
            <Col xs="12">
              <>
                {/* First Row: Heading + Buttons */}
                <Row className="align-items-center mb-3">
                  <Col xs="12">
                    <div className="d-flex justify-content-between align-items-center">
                      <div style={{ width: "20%" }}></div>
                      <div style={{ width: "60%", textAlign: "center" }}>
                        <h2 className="m-0">
                          <u>Sales Tax Invoice</u>
                        </h2>
                      </div>
                      <div style={{ width: "20%", textAlign: "end" }}>
                        <button
                          className="btn btn-primary mx-2"
                          id="printPageButton"
                          onClick={() => window.print()}
                        >
                          Print
                        </button>
                        <button
                          className="btn btn-primary"
                          id="printPageButton"
                          onClick={() => this.goBackToInvoice()}
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </Col>
                </Row>

                {/* Second Row: Logo + Company Info + Certificate */}
                <Row className="align-items-center text-center mt-3">
                  {/* Left: Logo */}
                  <Col xs="2" className="text-start">
                    <img
                      src={alQadirLogo}
                      alt="logo"
                      style={{
                        maxWidth: "100%",
                        height: "auto",
                        objectFit: "contain",
                      }}
                    />
                  </Col>

                  {/* Center: Company Info */}
                  <Col xs="8">
                    <h2>
                      <b>AL-QADIR TEXTILE MILLS LIMITED</b>
                    </h2>
                    <h5>6-KM JEHLAM ROAD, CHAKWAL (PAKISTAN)</h5>
                    <h6>
                      STRN: {compStrn}, NTN: {compNtn}
                    </h6>
                    <h6 className="bg-dark text-white p-2 d-flex justify-content-center">
                      Email: alqadirtex@yahoo.com, Tel: +92 543 540830-31-32-33
                    </h6>
                  </Col>

                  {/* Right: Certificate */}
                  <Col xs="2" className="text-end">
                    <img
                      src={alQadir}
                      alt="certificate"
                      style={{
                        maxWidth: "100%",
                        height: "auto",
                        objectFit: "contain",
                      }}
                    />
                  </Col>
                </Row>
              </>
              <br></br>
              <hr
                style={{
                  marginTop: "-0.5rem",
                  border: "1px solid Light gray",
                }}
              />
              <Row className="px-4 display-flex flex">
                <Col
                  xs="6"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    marginTop: "2%",
                    marginBottom: "2%",
                  }}
                >
                  <h2>
                    <b>{clientName}</b>
                  </h2>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      marginBottom: "8px",
                    }}
                  >
                    <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                      Address:
                    </h4>
                    <span style={{ marginLeft: "10px" }}>
                      <h5>{address}</h5>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      marginBottom: "8px",
                    }}
                  >
                    <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                      Phone:
                    </h4>
                    <span style={{ marginLeft: "10px" }}>
                      <h5>{phone}</h5>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      marginBottom: "8px",
                    }}
                  >
                    <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                      E-Mail:
                    </h4>
                    <span style={{ marginLeft: "10px" }}>
                      <h5>{email}</h5>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      marginBottom: "8px",
                    }}
                  >
                    <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                      NTN:
                    </h4>
                    <span style={{ marginLeft: "10px" }}>
                      <h5>{clntNtax}</h5>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      marginBottom: "8px",
                    }}
                  >
                    <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                      STRN:
                    </h4>
                    <span style={{ marginLeft: "10px" }}>
                      <h5>{clntStrn}</h5>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      marginBottom: "8px",
                    }}
                  >
                    <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                      CNIC:
                    </h4>
                    <span style={{ marginLeft: "10px" }}>
                      <h5>{clntCnic}</h5>
                    </span>
                  </div>
                </Col>
                <Col
                  xs="6"
                  className="px-4"
                  style={{
                    marginLeft: "76%", // Adjust the horizontal position as needed
                    marginTop: "-14.5%", // Adjust the vertical position as needed
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start", // Align all items to the start of the column
                  }}
                >
                  {/* Invoice Message and Number */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      marginBottom: "8px",
                    }}
                  >
                    <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                      {specificMsg ? specificMsg : dynamicInvMessage} No:
                    </h4>
                    <span style={{ marginLeft: "0px" }}>
                      <h5>{invoiceNo}</h5>
                    </span>
                  </div>

                  {/* PO Number (conditionally rendered) */}
                  {poNumber && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        marginBottom: "8px",
                      }}
                    >
                      <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                        PO Number:
                      </h4>
                      <span style={{ marginLeft: "0px" }}>
                        <h5>{poNumber}</h5>
                      </span>
                    </div>
                  )}

                  {/* Issue Date */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      marginBottom: "8px",
                    }}
                  >
                    <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                      Issue Date:
                    </h4>
                    <span style={{ marginLeft: "4px" }}>
                      <h5>{issueDate}</h5>
                    </span>
                  </div>

                  {/* Due Date */}
                  {/* <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      marginBottom: "8px",
                    }}
                  >
                    <h4 style={{ marginRight: "10px", minWidth: "100px" }}>
                      Due Date:
                    </h4>
                    <span style={{ marginLeft: "7px" }}>
                      <h5>{dueDate}</h5>
                    </span>
                  </div> */}
                </Col>
              </Row>
              <hr
                style={{
                  border: "0.5px solid #706f6f",
                  marginTop: "-2%",
                }}
              />
              <Row xs="12" className="px-4">
                <Col xs="12" className="">
                  <table
                    bordered
                    style={{ width: "100%" }}
                    className="my-table"
                  >
                    {res_det?.[0]?.ITEM_CODE?.startsWith("W") ? (
                      <colgroup>
                        <col style={{ width: "20%" }} />{" "}
                        <col style={{ width: "10%" }} /> {/* Unit column */}
                        <col style={{ width: "5%" }} /> {/* Qty column */}
                        <col style={{ width: "10%" }} /> {/* Rate column */}
                        <col style={{ width: "10%" }} />{" "}
                        <col style={{ width: "12%" }} />{" "}
                        <col style={{ width: "10%" }} />{" "}
                        <col style={{ width: "12%" }} />{" "}
                        {/* After Tax Amount column */}
                      </colgroup>
                    ) : (
                      <colgroup>
                        <col style={{ width: "20%" }} />{" "}
                        <col style={{ width: "10%" }} /> {/* Unit column */}
                        <col style={{ width: "5%" }} /> {/* Qty column */}
                        <col style={{ width: "10%" }} /> {/* Rate column */}
                        <col style={{ width: "12%" }} />{" "}
                        <col style={{ width: "10%" }} />{" "}
                        <col style={{ width: "12%" }} />{" "}
                        <col style={{ width: "10%" }} />{" "}
                        <col style={{ width: "12%" }} />{" "}
                        {/* After Tax Amount column */}
                      </colgroup>
                    )}
                    <thead>
                      <tr>
                        <th className="border">Description</th>
                        <th className="border">HS Code</th>
                        <th className="border text-right mr-1">Qty</th>
                        <th className="border text-right mr-1">Unit</th>
                        {res_det?.[0]?.ITEM_CODE?.startsWith("W") ? (
                          ""
                        ) : (
                          <th className="border text-right mr-1">
                            Weight (KG)
                          </th>
                        )}
                        <th className="border text-right mr-1">Price</th>
                        <th className="border text-right mr-1">
                          Value Excl. STax
                        </th>
                        <th className="border text-right mr-1">Sales Tax</th>
                        <th className="border text-right mr-1">
                          Value Incl. STax
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {res_det?.map((itm, index) => {
                        return (
                          <tr key={index}>
                            <td>{itm.item_desc}</td>
                            <td>{itm.hs_code ? itm.hs_code : "N/A"}</td>
                            <td className="text-right">
                              {itm.item_qty
                                ?.toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </td>
                            <td className="text-right mr-1">{itm.item_unit}</td>
                            {res_det?.[0]?.ITEM_CODE?.startsWith(
                              "W"
                            ) ? (
                              ""
                            ) : (
                              <td className="text-right">
                                {itm.ad_weight
                                  ?.toFixed(2)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              </td>
                            )}
                            <td className="text-right mr-2">
                              {/* {CURRENCY_DESC}{" "} */}
                              {itm.item_rate
                                ?.toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </td>
                            <td className="text-right mr-2">
                              {/* {CURRENCY_DESC}{" "} */}
                              {itm.item_bt_amount
                                ?.toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </td>
                            <td className="text-right mr-2">
                              {/* {CURRENCY_DESC}{" "} */}
                              {itm.item_sale_tax_amount
                                ?.toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </td>
                            <td className="text-right mr-2">
                              {/* {CURRENCY_DESC}{" "} */}
                              {itm.at_amount
                                ?.toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr
                        style={{
                          fontWeight: "bold",
                          borderTop: "2px solid #000",
                          borderBottom: "2px solid #000",
                        }}
                      >
                        <td className="text-center">Total(PKR)</td>
                        <td className="text-right"></td>
                        <td className="text-right"></td>
                        <td className="text-right"></td>
                        <td className="text-right"></td>
                        {res_det?.[0]?.ITEM_CODE?.startsWith("W") ? (
                          ""
                        ) : (
                          <td className="text-right"></td>
                        )}
                        <td className="text-right">
                          {total_btAmount
                            ?.toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          {/* 0.00 */}
                        </td>
                        <td className="text-right">
                          {totalsalesTax
                            ?.toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        </td>
                        <td className="text-right">
                          {total_Amount
                            ?.toFixed(2)
                            // .toString()
                            ?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </Col>

                <br></br>
                <br></br>
                <br></br>
                {/* <Col xs="10" className="">
                  <h4
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    Payment Terms: Invoice to be settled by {dueDate}
                  </h4>
                </Col> */}
              </Row>
            </Col>
            <Col xs="12" className="mt-2">
              <h4
                style={{
                  fontWeight: "bold",
                }}
              >
                <br></br>
                <br></br>
                <br></br>
                <br></br>
              <p style={{display:"none"}}>Payment Terms: Invoice to be settled by {dueDate}</p>
              </h4>
            </Col>
            <Container
              className={`${
                this.state.setNextPrintPageFooter
                  ? "footerNewPage"
                  : "footerPrint"
              }`}
              // className="footer"
              style={{ backgroundColor: "white" }}
            >
              <Row
                className="mt-5 footerRows"
                style={{
                  textAlign: "center",
                }}
              >
                {this.state.setFooterData.map((row) => (
                  <Col
                    lg="4"
                    md="4"
                    sm="4"
                    className="px-4"
                    style={{
                      // marginBottom: "3rem",
                      // marginTop: row.enteredBy != 1 ? "1.3rem" : "0",
                      marginTop: "-5rem",
                      textAlign: "center",
                    }}
                  >
                    <h5>
                      {" "}
                      {row.enteredBy
                        ? row.enteredBy /*printData[0]?.name*/
                        : "  "}
                    </h5>
                    <div
                      style={{
                        height: "5rem", // Reserve same space for every signature
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "0.5rem",
                      }}
                    >
                      {row.desc === "Prepared By" ? (
                        <img
                          src={Signature}
                          alt="signatures"
                          style={{
                            maxHeight: "100%",
                            maxWidth: "100%",
                            objectFit: "contain",
                          }}
                        />
                      ) : null}
                    </div>
                    <hr
                      style={{
                        border: "1px solid ",
                        borderColor: "E4E5E6",
                        margin: "revert",
                      }}
                    />
                    <h4 key={row.id}>{row.desc}</h4>
                  </Col>
                ))}
              </Row>
            </Container>
            {fbr_inv_id != "N/A" ? (
              <div className="fbr-logo-qr-code">
                <div
                  style={{
                    height: "auto",
                    maxWidth: 64,
                    width: "100%",
                  }}
                >
                  <img
                    src={FBRlogo}
                    alt="FBR Logo"
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                  />
                </div>
                <div
                  style={{
                    height: "auto",
                    marginLeft: "1rem",
                    maxWidth: 64,
                    width: "100%",
                  }}
                >
                  <QRCode
                    size={256}
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    value={fbr_inv_id}
                    viewBox={`0 0 256 256`}
                  />
                  FBR ID: {fbr_inv_id}
                </div>
              </div>
            ) : (
              ""
            )}
          </Row>
        </div>
      );
          })}
        </div>
      );
    } else {
      return (
        <div>
          <Row className="app-body-Invoice">
            <Col>
              <div className="col-md-12" style={{ width: "1100px", margin: "0 auto", padding: "50px", textAlign: "center" }}>
                <h2 style={{ color: "red", fontWeight: "bold" }}>
                  An error occurred while loading the prints.
                </h2>
                <p>
                  <strong>Debug info:</strong><br/>
                  Error Message: {this.state.errorMessage || "Unknown error"}<br/>
                  Invoice IDs received: {JSON.stringify(this.state.invoiceId)}<br/>
                  Loading response: {this.state.loadingResponce ? "true" : "false"}
                </p>
                <button
                  className="btn btn-primary mt-3"
                  onClick={() => this.goBackToInvoice()}
                >
                  Go Back
                </button>
              </div>
            </Col>
          </Row>
        </div>
      );
    }
  }
}

export default PrintView;
